function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Creator-2.0",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ingredients---Empty-1",
  transform: "translate(-644.000000, -834.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Appliances-Empty",
  transform: "translate(260.000000, 776.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(369.000000, 56.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "No-Appliances",
  transform: "translate(15.603448, 2.500000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M149.793103,97.5 C149.793103,56.07875 116.260669,22.5 74.8965517,22.5 C33.5324345,22.5 0,56.07875 0,97.5 L149.793103,97.5 Z",
  id: "Fill-2",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-4",
  fill: "#000000",
  points: "24.3413793 97.5 125.451724 97.5 125.451724 17.5 24.3413793 17.5"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-6",
  fill: "#929497",
  points: "24.3413793 17.5 125.451724 17.5 125.451724 0 24.3413793 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.962069,21.25 L31.8310345,21.25 C30.7968379,21.25 29.9586207,22.09 29.9586207,23.125 C29.9586207,24.16 30.7968379,25 31.8310345,25 L117.962069,25 C118.996266,25 119.834483,24.16 119.834483,23.125 C119.834483,22.09 118.996266,21.25 117.962069,21.25",
  id: "Fill-7",
  fill: "#929497"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.6,30 L41.1931034,30 C39.8143828,30 38.6965517,31.119375 38.6965517,32.5 L38.6965517,77.5 C38.6965517,78.880625 39.8143828,80 41.1931034,80 L108.6,80 C109.978721,80 111.096552,78.880625 111.096552,77.5 L111.096552,32.5 C111.096552,31.119375 109.978721,30 108.6,30",
  id: "Fill-8",
  fill: "#231F20"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.3862069,2.5 L67.4068966,2.5 C66.7178483,2.5 66.1586207,3.06 66.1586207,3.75 L66.1586207,13.75 C66.1586207,14.44 66.7178483,15 67.4068966,15 L82.3862069,15 C83.0752552,15 83.6344828,14.44 83.6344828,13.75 L83.6344828,3.75 C83.6344828,3.06 83.0752552,2.5 82.3862069,2.5",
  id: "Fill-9",
  fill: "#000000"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-10",
  fill: "#000000",
  points: "38.6965517 38.125 111.096552 38.125 111.096552 37.5 38.6965517 37.5"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-11",
  fill: "#000000",
  points: "38.6965517 43.125 111.096552 43.125 111.096552 42.5 38.6965517 42.5"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-12",
  fill: "#000000",
  points: "38.6965517 48.125 111.096552 48.125 111.096552 47.5 38.6965517 47.5"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-13",
  fill: "#000000",
  points: "38.6965517 53.125 111.096552 53.125 111.096552 52.5 38.6965517 52.5"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-14",
  fill: "#000000",
  points: "38.6965517 58.125 111.096552 58.125 111.096552 57.5 38.6965517 57.5"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-15",
  fill: "#000000",
  points: "38.6965517 63.125 111.096552 63.125 111.096552 62.5 38.6965517 62.5"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-16",
  fill: "#000000",
  points: "38.6965517 68.125 111.096552 68.125 111.096552 67.5 38.6965517 67.5"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-17",
  fill: "#000000",
  points: "38.6965517 73.125 111.096552 73.125 111.096552 72.5 38.6965517 72.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.4275862,9.375 C52.4275862,11.10125 51.0307655,12.5 49.3068966,12.5 C47.5830276,12.5 46.1862069,11.10125 46.1862069,9.375 C46.1862069,7.64875 47.5830276,6.25 49.3068966,6.25 C51.0307655,6.25 52.4275862,7.64875 52.4275862,9.375",
  id: "Fill-18",
  fill: "#404041"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.4137931,9.375 C62.4137931,11.10125 61.0169724,12.5 59.2931034,12.5 C57.5692345,12.5 56.1724138,11.10125 56.1724138,9.375 C56.1724138,7.64875 57.5692345,6.25 59.2931034,6.25 C61.0169724,6.25 62.4137931,7.64875 62.4137931,9.375",
  id: "Fill-19",
  fill: "#404041"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.4413793,9.375 C42.4413793,11.10125 41.0439345,12.5 39.3206897,12.5 C37.5974448,12.5 36.2,11.10125 36.2,9.375 C36.2,7.64875 37.5974448,6.25 39.3206897,6.25 C41.0439345,6.25 42.4413793,7.64875 42.4413793,9.375",
  id: "Fill-20",
  fill: "#404041"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.606897,9.375 C103.606897,11.10125 102.210076,12.5 100.486207,12.5 C98.7623379,12.5 97.3655172,11.10125 97.3655172,9.375 C97.3655172,7.64875 98.7623379,6.25 100.486207,6.25 C102.210076,6.25 103.606897,7.64875 103.606897,9.375",
  id: "Fill-21",
  fill: "#404041"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.593103,9.375 C113.593103,11.10125 112.196283,12.5 110.472414,12.5 C108.748545,12.5 107.351724,11.10125 107.351724,9.375 C107.351724,7.64875 108.748545,6.25 110.472414,6.25 C112.196283,6.25 113.593103,7.64875 113.593103,9.375",
  id: "Fill-22",
  fill: "#404041"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.6206897,9.375 C93.6206897,11.10125 92.223869,12.5 90.5,12.5 C88.776131,12.5 87.3793103,11.10125 87.3793103,9.375 C87.3793103,7.64875 88.776131,6.25 90.5,6.25 C92.223869,6.25 93.6206897,7.64875 93.6206897,9.375",
  id: "Fill-23",
  fill: "#404041"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-24",
  fill: "#006699",
  points: "19.9724138 95 43.6896552 95 43.6896552 63.75 19.9724138 63.75"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-25",
  fill: "#003366",
  points: "19.9724138 97.5 43.6896552 97.5 43.6896552 95 19.9724138 95"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.1917866,18.75 L21.4704072,18.75 C20.6434245,18.75 19.9724762,19.42125 19.9724762,20.25 L19.9724762,21.25 L43.6897176,21.25 L43.6897176,20.25 C43.6897176,19.42125 43.0187693,18.75 42.1917866,18.75",
  id: "Fill-26",
  fill: "#006699"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.9310345,40 C49.9310345,42.070625 48.2539759,43.75 46.1862069,43.75 L43.6896552,43.75 L43.6896552,25 L48.0586207,25 C49.0928172,25 49.9310345,25.84 49.9310345,26.875 L49.9310345,40 Z M48.1210345,21.25 L43.6896552,21.25 L19.9724138,21.25 C17.2149724,21.25 14.9793103,23.48875 14.9793103,26.25 C17.7367517,26.25 19.9724138,28.48875 19.9724138,31.25 L19.9724138,63.75 L43.6896552,63.75 L43.6896552,47.5 L46.1862069,47.5 C50.322369,47.5 53.6758621,44.141875 53.6758621,40 L53.6758621,26.875 C53.6758621,23.768125 51.223,21.25 48.1210345,21.25 L48.1210345,21.25 Z",
  id: "Fill-27",
  fill: "#91EDE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.2206897,21.25 L21.2206897,23.75 C21.2206897,25.130625 22.3385207,26.25 23.7172414,26.25 L39.9448276,26.25 C41.3235483,26.25 42.4413793,25.130625 42.4413793,23.75 L42.4413793,21.25 L21.2206897,21.25 Z",
  id: "Fill-28",
  fill: "#3399CC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.9724138,82.5 L19.9724138,85 C19.9724138,87.76125 22.2080759,90 24.9655172,90 L38.6965517,90 C41.4539931,90 43.6896552,87.76125 43.6896552,85 L43.6896552,82.5 L19.9724138,82.5 Z",
  id: "Fill-29",
  fill: "#3399CC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.9655172,85 L23.7172414,85 C23.0281931,85 22.4689655,85.56 22.4689655,86.25 C22.4689655,86.94 23.0281931,87.5 23.7172414,87.5 L24.9655172,87.5 C25.6545655,87.5 26.2137931,86.94 26.2137931,86.25 C26.2137931,85.56 25.6545655,85 24.9655172,85",
  id: "Fill-30",
  fill: "#003366"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.9586207,85 L28.7103448,85 C28.0212966,85 27.462069,85.56 27.462069,86.25 C27.462069,86.94 28.0212966,87.5 28.7103448,87.5 L29.9586207,87.5 C30.647669,87.5 31.2068966,86.94 31.2068966,86.25 C31.2068966,85.56 30.647669,85 29.9586207,85",
  id: "Fill-31",
  fill: "#003366"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.9517241,85 L33.7034483,85 C33.0144,85 32.4551724,85.56 32.4551724,86.25 C32.4551724,86.94 33.0144,87.5 33.7034483,87.5 L34.9517241,87.5 C35.6407724,87.5 36.2,86.94 36.2,86.25 C36.2,85.56 35.6407724,85 34.9517241,85",
  id: "Fill-32",
  fill: "#003366"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.9448276,85 L38.6965517,85 C38.0075034,85 37.4482759,85.56 37.4482759,86.25 C37.4482759,86.94 38.0075034,87.5 38.6965517,87.5 L39.9448276,87.5 C40.6338759,87.5 41.1931034,86.94 41.1931034,86.25 C41.1931034,85.56 40.6338759,85 39.9448276,85",
  id: "Fill-33",
  fill: "#003366"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-34",
  fill: "#FFFFFF",
  points: "30.5827586 29.375 33.0793103 29.375 33.0793103 28.75 30.5827586 28.75"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-35",
  fill: "#FFFFFF",
  points: "30.5827586 32.5 33.0793103 32.5 33.0793103 31.875 30.5827586 31.875"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-36",
  fill: "#FFFFFF",
  points: "30.5827586 35.625 33.0793103 35.625 33.0793103 35 30.5827586 35"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-37",
  fill: "#FFFFFF",
  points: "30.5827586 38.75 33.0793103 38.75 33.0793103 38.125 30.5827586 38.125"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-38",
  fill: "#FFFFFF",
  points: "30.5827586 41.875 33.0793103 41.875 33.0793103 41.25 30.5827586 41.25"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-39",
  fill: "#FFFFFF",
  points: "30.5827586 45 33.0793103 45 33.0793103 44.375 30.5827586 44.375"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-40",
  fill: "#FFFFFF",
  points: "30.5827586 48.125 33.0793103 48.125 33.0793103 47.5 30.5827586 47.5"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-41",
  fill: "#FFFFFF",
  points: "30.5827586 51.25 33.0793103 51.25 33.0793103 50.625 30.5827586 50.625"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-42",
  fill: "#FFFFFF",
  points: "30.5827586 54.375 33.0793103 54.375 33.0793103 53.75 30.5827586 53.75"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-43",
  fill: "#FFFFFF",
  points: "30.5827586 57.5 33.0793103 57.5 33.0793103 56.875 30.5827586 56.875"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-44",
  fill: "#FFFFFF",
  points: "30.5827586 60.625 33.0793103 60.625 33.0793103 60 30.5827586 60"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.4482759,72.5 C37.4482759,75.606875 34.9336241,78.125 31.8310345,78.125 C28.7284448,78.125 26.2137931,75.606875 26.2137931,72.5 C26.2137931,69.393125 28.7284448,66.875 31.8310345,66.875 C34.9336241,66.875 37.4482759,69.393125 37.4482759,72.5",
  id: "Fill-45",
  fill: "#003366"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.3004734,71.46425 L28.741739,71.906125 C29.1430597,71.50425 29.610539,71.18925 30.1304459,70.968625 C30.6690769,70.7405 31.2407872,70.624875 31.8312217,70.624875 C32.4210321,70.624875 32.9933666,70.7405 33.5313734,70.968625 C34.0512803,71.18925 34.5187597,71.50425 34.9200803,71.906125 L35.3613459,71.46425 C34.4582183,70.559875 33.2099424,69.999875 31.8312217,69.999875 C30.452501,69.999875 29.2042252,70.559875 28.3004734,71.46425",
  id: "Fill-46",
  fill: "#CCFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.1830045,72.348625 L29.62427,72.7905 C30.2134562,72.2005 30.9973734,71.874875 31.8312217,71.874875 C32.6644459,71.874875 33.4483631,72.2005 34.0375493,72.7905 L34.4788148,72.348625 C33.801001,71.669875 32.8647941,71.249875 31.8312217,71.249875 C30.7970252,71.249875 29.8608183,71.669875 29.1830045,72.348625",
  id: "Fill-47",
  fill: "#CCFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.0655979,73.2324375 L30.5074876,73.6743125 C30.8607497,73.3205625 31.3307255,73.1249375 31.8312841,73.1249375 C32.3312186,73.1249375 32.8011945,73.3205625 33.1550807,73.6743125 L33.5963462,73.2324375 C33.1444703,72.7793125 32.5203324,72.4999375 31.8312841,72.4999375 C31.1416117,72.4999375 30.5174738,72.7793125 30.0655979,73.2324375",
  id: "Fill-48",
  fill: "#CCFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.7136279,74.1161875 C32.48769,73.8899375 32.175621,73.7499375 31.8310969,73.7499375 C31.4865728,73.7499375 31.1745038,73.8899375 30.9485659,74.1161875 L31.8310969,74.9999375 L32.7136279,74.1161875 Z",
  id: "Fill-49",
  fill: "#CCFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.224138,43.75 C109.224138,47.201875 112.019028,50 115.465517,50 L129.196552,50 C132.643041,50 135.437931,47.201875 135.437931,43.75 L109.224138,43.75 Z",
  id: "Fill-50",
  fill: "#CC3333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.2586207,95 C84.2586207,96.380625 85.3764517,97.5 86.7551724,97.5 L142.927586,97.5 C144.306307,97.5 145.424138,96.380625 145.424138,95 L84.2586207,95 Z",
  id: "Fill-51",
  fill: "#CC3333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.82069,81.25 L114.841379,81.25 C113.462659,81.25 112.344828,82.369375 112.344828,83.75 L132.317241,83.75 C132.317241,82.369375 131.19941,81.25 129.82069,81.25",
  id: "Fill-52",
  fill: "#CC3333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.437931,83.75 L104.231034,83.75 C101.473593,83.75 99.237931,81.51125 99.237931,78.75 L99.237931,48.75 C99.237931,45.98875 101.473593,43.75 104.231034,43.75 L135.437931,43.75 C135.437931,35.465625 128.731569,28.75 120.458621,28.75 L104.231034,28.75 C93.2006448,28.75 84.2586207,37.704375 84.2586207,48.75 L84.2586207,95 L145.424138,95 L145.424138,93.75 C145.424138,88.2275 140.953438,83.75 135.437931,83.75",
  id: "Fill-53",
  fill: "#FF6666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.855172,52.5 L104.855172,66.25 C104.855172,74.534375 111.561534,81.25 119.834483,81.25 L124.827586,81.25 C133.100534,81.25 139.806897,74.534375 139.806897,66.25 L139.806897,52.5 L104.855172,52.5 Z",
  id: "Fill-54",
  fill: "#6D6E70"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.182759,50 L105.47931,50 C104.10059,50 102.982759,51.119375 102.982759,52.5 L141.67931,52.5 C141.67931,51.119375 140.561479,50 139.182759,50",
  id: "Fill-55",
  fill: "#D0D2D3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.3068966,86.25 L50.8978241,93.349375 C51.2773,95.04375 52.7927069,96.25 54.5427897,96.25 L87.7606586,96.25 C89.5107414,96.25 91.0261483,95.04375 91.4056241,93.349375 L92.9965517,86.25 L49.3068966,86.25 Z",
  id: "Fill-56",
  fill: "#FFFAE6"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-57",
  fill: "#77001A",
  points: "54.3 97.5 88.0034483 97.5 88.0034483 96.25 54.3 96.25"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.9965517,86.25 L49.3068966,86.25 L48.6827586,90.625 L56.5281724,90.625 C59.7555897,90.625 62.9436862,91.539375 65.5482138,93.394375 C66.9350483,94.380625 68.9316655,95 71.1517241,95 C73.3717828,95 75.3684,94.380625 76.7552345,93.394375 C79.3597621,91.539375 82.5478586,90.625 85.7752759,90.625 L93.6206897,90.625 L92.9965517,86.25 Z",
  id: "Fill-58",
  fill: "#B31B34"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.1517241,87.5 C69.6007414,87.5 68.3431034,88.34 68.3431034,89.375 C68.3431034,90.41 69.6007414,91.25 71.1517241,91.25 C72.7027069,91.25 73.9603448,90.41 73.9603448,89.375 C73.9603448,88.34 72.7027069,87.5 71.1517241,87.5",
  id: "Fill-59",
  fill: "#77001A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.4830852,7.4554375 L71.0348231,8.0079375 C71.53663,7.5054375 72.1208231,7.1110625 72.7711748,6.8360625 C73.4439955,6.5510625 74.1592576,6.4060625 74.8963645,6.4060625 C75.6340955,6.4060625 76.3487334,6.5510625 77.0221783,6.8360625 C77.67253,7.1110625 78.256099,7.5054375 78.75853,8.0079375 L79.3102679,7.4554375 C78.1805783,6.3241875 76.6202334,5.6248125 74.8963645,5.6248125 C73.1731197,5.6248125 71.6127748,6.3241875 70.4830852,7.4554375",
  id: "Fill-60",
  fill: "#CCFFCC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.5863114,8.5601875 L72.1386734,9.1133125 C72.8745321,8.3751875 73.8544286,7.9689375 74.896739,7.9689375 C75.9390493,7.9689375 76.9183217,8.3751875 77.6548045,9.1133125 L78.2065424,8.5601875 C77.3595872,7.7126875 76.1893286,7.1876875 74.896739,7.1876875 C73.6035252,7.1876875 72.4332666,7.7126875 71.5863114,8.5601875",
  id: "Fill-61",
  fill: "#CCFFCC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.6900993,9.6655 L73.2418372,10.218 C73.6837269,9.774875 74.2710407,9.531125 74.8964269,9.531125 C75.5218131,9.531125 76.109751,9.774875 76.5516407,10.218 L77.1027545,9.6655 C76.5385338,9.099875 75.7583614,8.749875 74.8964269,8.749875 C74.0344924,8.749875 73.25432,9.099875 72.6900993,9.6655",
  id: "Fill-62",
  fill: "#CCFFCC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.9997779,10.77025 C75.7176676,10.48775 75.3275814,10.31275 74.8963021,10.31275 C74.4656469,10.31275 74.0755607,10.48775 73.7934503,10.77025 L74.8963021,11.87525 L75.9997779,10.77025 Z",
  id: "Fill-63",
  fill: "#CCFFCC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.948276,41.875 C127.948276,44.981875 125.433624,47.5 122.331034,47.5 C119.228445,47.5 116.713793,44.981875 116.713793,41.875 C116.713793,38.768125 119.228445,36.25 122.331034,36.25 C125.433624,36.25 127.948276,38.768125 127.948276,41.875",
  id: "Fill-64",
  fill: "#990000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.800161,40.83925 L119.241427,41.281125 C119.643372,40.87925 120.110851,40.56425 120.630758,40.343625 C121.168765,40.1155 121.741099,39.999875 122.33091,39.999875 C122.921344,39.999875 123.493679,40.1155 124.031686,40.343625 C124.551592,40.56425 125.019072,40.87925 125.420392,41.281125 L125.861658,40.83925 C124.957906,39.934875 123.70963,39.374875 122.33091,39.374875 C120.952189,39.374875 119.703913,39.934875 118.800161,40.83925",
  id: "Fill-65",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.683317,41.723625 L120.124582,42.1655 C120.713768,41.5755 121.497061,41.249875 122.33091,41.249875 C123.164758,41.249875 123.948051,41.5755 124.537237,42.1655 L124.978503,41.723625 C124.301313,41.044875 123.365106,40.624875 122.33091,40.624875 C121.296713,40.624875 120.360506,41.044875 119.683317,41.723625",
  id: "Fill-66",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.56591,42.6074375 L121.007176,43.0493125 C121.360438,42.6955625 121.830413,42.4999375 122.330972,42.4999375 C122.831531,42.4999375 123.301507,42.6955625 123.654769,43.0493125 L124.096034,42.6074375 C123.644782,42.1543125 123.020644,41.8749375 122.330972,41.8749375 C121.641924,41.8749375 121.017786,42.1543125 120.56591,42.6074375",
  id: "Fill-67",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.213628,43.4911875 C122.988314,43.2649375 122.676245,43.1249375 122.331097,43.1249375 C121.985949,43.1249375 121.67388,43.2649375 121.448566,43.4911875 L122.331097,44.3749375 L123.213628,43.4911875 Z",
  id: "Fill-68",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.468956,88.6700625 L115.717232,88.6700625 C116.40628,88.6700625 116.965508,88.1106875 116.965508,87.4200625 C116.965508,86.7300625 116.40628,86.1700625 115.717232,86.1700625 L114.468956,86.1700625 C113.779908,86.1700625 113.22068,86.7300625 113.22068,87.4200625 C113.22068,88.1106875 113.779908,88.6700625 114.468956,88.6700625",
  id: "Fill-69",
  fill: "#990000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.46206,88.6700625 L120.710336,88.6700625 C121.399384,88.6700625 121.958611,88.1106875 121.958611,87.4200625 C121.958611,86.7300625 121.399384,86.1700625 120.710336,86.1700625 L119.46206,86.1700625 C118.773011,86.1700625 118.213784,86.7300625 118.213784,87.4200625 C118.213784,88.1106875 118.773011,88.6700625 119.46206,88.6700625",
  id: "Fill-70",
  fill: "#990000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.455163,88.6700625 L125.703439,88.6700625 C126.392487,88.6700625 126.951715,88.1106875 126.951715,87.4200625 C126.951715,86.7300625 126.392487,86.1700625 125.703439,86.1700625 L124.455163,86.1700625 C123.766115,86.1700625 123.206887,86.7300625 123.206887,87.4200625 C123.206887,88.1106875 123.766115,88.6700625 124.455163,88.6700625",
  id: "Fill-71",
  fill: "#990000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.448267,88.6700625 L130.696542,88.6700625 C131.385591,88.6700625 131.944818,88.1106875 131.944818,87.4200625 C131.944818,86.7300625 131.385591,86.1700625 130.696542,86.1700625 L129.448267,86.1700625 C128.759218,86.1700625 128.199991,86.7300625 128.199991,87.4200625 C128.199991,88.1106875 128.759218,88.6700625 129.448267,88.6700625",
  id: "Fill-72",
  fill: "#990000"
}))))));

function SvgAppliancesEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "151px",
    height: "98px",
    viewBox: "0 0 151 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration/Appliances empty state") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliancesEmptyState);
export default __webpack_public_path__ + "static/media/appliances-empty-state.95e5268b.svg";
export { ForwardRef as ReactComponent };